export const BIOMETRICS_BLOCKING_CONSENT_INIT = 'BIOMETRICS_BLOCKING_CONSENT_INIT';
export const BIOMETRICS_IS_COMPLETED_SUCCESS = 'BIOMETRICS_IS_COMPLETED_SUCCESS';
export const BIOMETRICS_IS_INITIALIZED = 'BIOMETRICS_IS_INITIALIZED';

export const BIOMETRICS_ONBOARDING_FLOW = 'ONBOARDING';
export const BIOMETRICS_EXISTING_USER_FLOW = 'EXISTING_USER';

export const BIOMETRICS_CONSENT_REQUIRED_STATE = 'consent_required';
export const BIOMETRICS_LIVENESS_AND_CONSENT_REQUIRED_STATE = 'liveness_and_consent_required';
export const BIOMETRICS_PASSED_STATE = 'passed';
export const BIOMETRICS_NOT_REQUIRED_STATE = 'not_required';
